import { Form, InputNumber, Select } from "antd";
import { Dispatch, ReactElement, SetStateAction, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import clssnames from "classnames";

import { TAccBalanceData, TCurrency } from "../../types/types";
import { getAvailableBalances } from "../../services/dashboard/dashboard.service";
import { QueryKeys } from "../../enums/react-query";
import { currencyFormatter } from "../../utils/helper";

type Prop = {
  currencies: TCurrency[] | undefined;
  setSelectedCurrency: Dispatch<SetStateAction<TCurrency | undefined>>;
  selectedCurrency: TCurrency | undefined;
};

export const FiatDepositForm = ({
  currencies,
  setSelectedCurrency,
  selectedCurrency,
}: Prop): ReactElement => {
  const { Option } = Select;
  const [availBal, setAvailBal] = useState<number | undefined>();

  const { data: accBalData } = useQuery({
    queryKey: [QueryKeys.GETAVAILABLEBALANCES],
    queryFn: async () => {
      const res = await getAvailableBalances();
      return res.data;
    },
  });

  const fiatCurrencies = currencies?.filter((cur) => cur.code !== "USDC") ?? [];

  const handleSelectCurrency = (currencyId: string) => {
    // find the selected currency from currency list
    const selectedCurrency = fiatCurrencies.find(
      (cur) => cur._id === currencyId,
    );

    // find the fund account for the selected currency
    const matchedAccount: TAccBalanceData | undefined =
      accBalData?.payload?.find(
        (acc: TAccBalanceData) => acc.currencyId === currencyId,
      );

    // update state of both selected currency and available balance from the account of selected currency
    setAvailBal(matchedAccount?.availableBalance);
    setSelectedCurrency(selectedCurrency);
  };

  return (
    <>
      <Form.Item
        name="fiatAccount"
        label="Currency"
        className="flex-1"
        rules={[
          {
            required: true,
            message: "Currency required",
          },
        ]}
      >
        <Select
          showSearch
          placeholder="Select currency"
          filterOption={(input, option) =>
            ((option?.value as string) || "")
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          //   loading={handleSelectCurrency}
          onChange={handleSelectCurrency}
          className="Nunito h-[44px] bg-[#F9FAFB] !border-[1px] !border-[#D1D5DB] focus:!shadow-[0_0px_0px_1px_#ffa30094] rounded-[8px] !text-[16px] !font-[300] !text-[#667085]"
        >
          {fiatCurrencies.map((datum: TCurrency, index: number) => {
            return (
              <Option key={datum?._id} value={datum?._id} className="!p-2 ">
                <div className="flex w-full items-center gap-[5px] truncate">
                  <span className="w-[20px] h-[20px] rounded-full overflow-hidden mr-[2px]">
                    <img src={datum?.flag} className="w-full h-full" />
                  </span>
                  {datum?.name}
                </div>
              </Option>
            );
          })}
        </Select>
      </Form.Item>
      <Form.Item
        name="fiatAmount"
        label="Deposit Amount"
        rules={[
          {
            required: true,
            message: "Please input a withdrawal amount!",
          },
        ]}
      >
        <InputNumber
          min={0}
          // max={selectedFiatAccountBalance}
          className="Nunito w-full h-[44px] flex items-center !px-[4px] bg-[#F9FAFB] border-[1px] !border-[#D1D5DB] focus-within:!shadow-[0_0px_0px_1px_#ffa30094] focus:!shadow-[0_0px_0px_1px_#ffa30094] rounded-[8px] text-[16px] !font-[300] !text-[#667085] "
          placeholder="Deposit amount"
        />
      </Form.Item>
      <div className="flex items-center justify-end -mt-[22px]">
        <p
          className={clssnames(
            { hidden: availBal === undefined },
            "text-brand-darkYellow text-[11px] font-[500] align-right",
          )}
        >
          Avail Bal: {selectedCurrency?.symbol}
          {currencyFormatter(availBal)}
        </p>
      </div>
    </>
  );
};
